import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { HoverContainerProvider } from './HoverContainer.context';
import Content from './components/Content';
import { ChildrenPropType } from '../../services/proptypes';
import { classNames } from '../../utils/classname';
import './HoverContainer.css';
var defaultProps = {
  className: '',
  defaultIsHovered: false,
  displayOnTouchScreen: true,
  forceDisplay: false
};
function HoverContainer(_ref) {
  var className = _ref.className,
    children = _ref.children,
    defaultIsHovered = _ref.defaultIsHovered,
    displayOnTouchScreen = _ref.displayOnTouchScreen,
    forceDisplay = _ref.forceDisplay;
  var _useState = useState(defaultIsHovered),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var context = {
    isHovered: forceDisplay ? true : isHovered,
    displayOnTouchScreen: displayOnTouchScreen
  };
  var finalClassName = classNames(_defineProperty({
    'hover-container': true,
    'hover-container-hovered': isHovered
  }, className, true));
  return /*#__PURE__*/React.createElement(HoverContainerProvider, {
    value: context
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    className: finalClassName
  }, children));
}
HoverContainer.Content = Content;
HoverContainer.defaultProps = defaultProps;
export default HoverContainer;